/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HappyPdfIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function HappyPdfIcon({
  children,
  viewPath = "/DesignSystem/Svgs/HappyPdfIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 40,
  height = 52,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#C7F1D6",
  fill2 = "#F7F7F7",
  fill3 = "#00CE7C",
  fill4 = "none",
  stroke = "#00CE7C"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="HappyPdfIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 40 52"
 style={{'--as-1-Z1NUa0l': alignSelf,'--mt-2-Z1NUa0l': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1NUa0l': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1NUa0l': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1NUa0l': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1NUa0l': opacity,'--w-10-Z1NUa0l': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1NUa0l': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1NUa0l': isAnimated ? animation : "none",'--sd-8-Z1NUa0l': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1NUa0l': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="HappyPdfIcon.SvgPath"
  data-view-path={viewPath}
 d="M29 0H3.6C1.6 0 0 1.6 0 3.6v44.7c0 2 1.6 3.6 3.6 3.6h32.7c2 0 3.6-1.6 3.6-3.6V11L29 0z"
 style={{'--f-12-Z1NUa0l': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="HappyPdfIcon.SvgPath:1"
  data-view-path={viewPath}
 d="M29 7.4c0 2 1.6 3.6 3.6 3.6H40L29 0v7.4z"
 style={{'--f-12-Z1NUa0l': fill2}}
 className={`views-block ${styles.SvgPath1}`}
/>
<g
  data-testid="HappyPdfIcon.SvgGroup"
  data-view-path={viewPath}
 className="views-block"
>
<path
  data-testid="HappyPdfIcon.SvgPath:2"
  data-view-path={viewPath}
 d="M12 29c0 4.6 3.7 8.2 8.2 8.2s8.2-3.7 8.2-8.2H12z"
 style={{'--f-12-Z1NUa0l': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="HappyPdfIcon.SvgPath:3"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeLinecap="round"
 strokeMiterlimit={10}
 d="M22.8 22.8c0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6M12.8 22.8c0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6"
 style={{'--f-12-Z1NUa0l': fill4,'--s-13-Z1NUa0l': stroke}}
 className={`views-block ${styles.SvgPath3}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}